import {useEffect, useState} from "react";
import {Navigation} from "./components/navigation";
import {Header} from "./components/header";
import {About} from "./components/about";
import {Services} from "./components/services";
import {Gallery} from "./components/gallery";
import {Contact} from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import {Cta} from "./components/cta";

export const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
});

const App = () => {
    const [landingPageData, setLandingPageData] = useState({});
    useEffect(() => {
        setLandingPageData(JsonData);
    }, []);

    return (
        <div>
            <Navigation/>
            <Header data={landingPageData.Header}/>
            <About data={landingPageData.About}/>
            <Cta/>
            {/*<Features data={landingPageData.Features} />*/}
            {/*<Testimonials data={landingPageData.Testimonials} />*/}
            {/*<Team data={landingPageData.Team} />*/}
            <Contact data={landingPageData.Contact}/>
        </div>
    );
};

export default App;
